import ViewContact from './ViewContact';

export default ViewContact;
